import { CompanionChat } from './components/CompanionChat';
import { LoginForm } from './components/LoginForm';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import { ThemeProvider } from './contexts/ThemeContext';
import { Spinner } from './components/Spinner';

function AppContent() {
  const { isAuthenticated, isLoading } = useAuth();

  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center" style={{ backgroundColor: 'var(--color-base-200)' }}>
        <div className="text-center">
          <Spinner />
          <p className="mt-4" style={{ color: 'var(--color-neutral-content)' }}>Loading...</p>
        </div>
      </div>
    );
  }

  return isAuthenticated ? <CompanionChat /> : <LoginForm />;
}

function App() {
  return (
    <AuthProvider>
      <ThemeProvider>
        <AppContent />
      </ThemeProvider>
    </AuthProvider>
  );
}

export default App;